(function ($, root, undefined) {

    $(function () {

        'use strict';

        // Global vars
        var stickyHide = 0;

        // DOM ready, take it away
        $('html').removeClass('no-js');

        if ($('#search').length !== 0 && $('body').hasClass('home')) {
            initSearchAnimation();
        }
        initHeader();
        viewportHeightFixer();
        initBtnScroll();
        initCustomSelectors();
        initCustomCheckbox();
        initBreadCrumbClamp();
        initSquares();
        initVideos();
        initAccordeons();
        initClickMenuDM();
        initOptisAccessibilite();
        
        var lazyLoadInstance = new LazyLoad({
        // Your custom settings go here
        });
        if($('body').hasClass('page-template-actualites') || $('body').hasClass('page-template-communiques') || $('body').hasClass('page-template-paroles-president') || $('body').hasClass('page-template-filmographie') || $('body').hasClass('page-template-mes-epingles') || $('body').hasClass('page-template-mes-recherches-enregistrees')) {
            initCategoriesCarousel();
        } else {
            initCarousels();            
        }
        initGallery();
        setStickyElements();
        initProgressBar();
        if ($('body').hasClass('page-template-communes')) {
            initCommunes();
        }
        initAideMarketee();
        if ($('body').hasClass('home')) {
            showSearchOnScroll();
        }
        if ($('body').find('.bloc-contact').length !== 0) {
            initFormLabels();
            initListSignup();
        }

        $(document).ajaxComplete(function() {
            // permet d'avoir les sélecteurs bootstrap sur la page de recherche
            initCustomSelectors();
        });
        

        // Temporaire
        if($('body').hasClass('single-post')){
            initFixLiensActus();
        }
        
        setAidesParams();


        /************
          FUNCTIONS
        *************/
        function initFixLiensActus() {
            var currentPath = window.location.href;
            var splittedPath = currentPath.split('actualites/')[0];
            var postContent = $('.post-content');
            if (!postContent.hasClass('no-urls')) {
                var links = postContent.find('a');

                links.each(function() {
                    var url = $(this).attr('href');
                    if (url.indexOf('jcms/') >= 0) {
                        var splittedUrl = url.split('/fr/')[1];
                        var newUrl = splittedPath + 'actualites/' + splittedUrl;
                        $(this).attr('href', newUrl);
                    }
                });
            }
        }

        function initHeader() {            
            var menu = $('.menu_slide');
            var isMenuOpen = false;
            var scrollDistance;
            var body = $('body');
            var html = $('html');
            var searchMobile = $('#search-mobile');

            // Menu burger
            $('header .nav .burger').click(function(e){
                e.preventDefault();
                e.stopPropagation();
                var expanded =  $(this).attr('aria-expanded');
                if (expanded === 'false') {
                    $(this).attr('aria-expanded','true')
                } else {
                    $(this).attr('aria-expanded','false')
                }

                menu.toggleClass('active');
                searchMobile.fadeToggle(300);

                if ($(window).width() < 1200) {                    
                    if (menu.hasClass('active')) {
                        scrollDistance = $(window).scrollTop();
                        body.css("top", scrollDistance * -1);
                        html.addClass('is-fixed');
                    } else {
                        html.removeClass('is-fixed');
                        body.css("top", "");
                        $(window).scrollTop(scrollDistance);
                    }
                }

                var navBtn = $(this);
                navBtn.toggleClass('active');

                var submenu = $('.sub-menu');

                if (isMenuOpen) {
                    isMenuOpen = false;

                    menu.scrollTop(0);
                    menu.removeClass('is-level2');
                    menu.removeClass('is-level3');
                    menu.removeClass('is-submenu');
                    menu.removeClass('is-submenued');
                    submenu.removeClass('is-active');
                    setTimeout(function() {                               
                        submenu.removeClass('is-actived');
                        menu.removeClass('is-overflowed');
                    }, 250);
                    menu.find('.slide-content').removeAttr('style');
                } else {
                    isMenuOpen = true;

                    if ($(window).width() > 768) {
                        $(document).one('click', function closeMenu (e){
                            if($('.menu_slide').has(e.target).length === 0){
                                isMenuOpen = false;

                                menu.removeClass('active');
                                searchMobile.fadeIn(300);
                                if ($(window).width() < 1200) {
                                    html.removeClass('is-fixed');
                                    body.css("top", "");
                                    $(window).scrollTop(scrollDistance);
                                }
                                navBtn.removeClass('active');

                                menu.scrollTop(0);
                                menu.removeClass('is-level2');
                                menu.removeClass('is-level3');
                                menu.removeClass('is-submenu');
                                menu.removeClass('is-submenued');
                                submenu.removeClass('is-active');
                                setTimeout(function() {
                                    submenu.removeClass('is-actived');
                                    menu.removeClass('is-overflowed');
                                }, 250);
                                menu.find('.slide-content').removeAttr('style');
                            } else {
                                $(document).one('click', closeMenu);
                            }
                        });
                    }
                }
            });

            //Menu caché ou pas selon le scroll
            var didScroll;
            var lastScrollTop = 0;
            var delta = 5;
            var navbarHeight = $('header').outerHeight();

            $(window).scroll(function(event){
                didScroll = true;
            });

            setInterval(function() {
                if($(window).width()<1200){
                    if (didScroll && !isMenuOpen) {
                        hasScrolled(); 
                        didScroll = false;
                    }
                }else{
                    $('header').removeClass('nav-up');
                }
            }, 250);

            function hasScrolled() {
                var st = $(document).scrollTop();
                // Make sure they scroll more than delta
                if(Math.abs(lastScrollTop - st) <= delta)
                    return;

                // If they scrolled down and are past the navbar, add class .nav-up.
                // This is necessary so you never see what is "behind" the navbar.
                if (st > lastScrollTop && st > navbarHeight){
                    // Scroll Down
                    $('header').removeClass('nav-down').addClass('nav-up');
                   $('#message-bandeau').removeClass('nav-down').addClass('nav-up');
                } else {
                    // Scroll Up
                    if(st + $(window).height() < $(document).height()) {
                        $('header').removeClass('nav-up').addClass('nav-down');
                        $('#message-bandeau').removeClass('nav-up').addClass('nav-down');
                        menu.removeClass('active');
                    }
                }
                lastScrollTop = st;
            }

            // Menu et sous-menu
            function navHandler() {
                menu.find('.menu-item-has-children > button').on('click', function(e) {
                    e.preventDefault();
                    menu.addClass('is-submenu');
                    menu.addClass('is-submenued');
                    menu.addClass('is-overflowed');
                    $(this).siblings('.sub-menu').addClass('is-active');
                    $(this).siblings('.sub-menu').addClass('is-actived');

                    var height = $(this).siblings('.sub-menu').innerHeight() + 140;	
                    var menuHeight =  menu.height();	

                    if (height >= menuHeight && $(window).width() < 992) {                    	
                        menu.find('.slide-content').height(height);	
                    }

                    // si élément du 3ème niveau
                    if ($(this).parents('.menu-item').parents('.menu-item').parents('.menu-item').hasClass('menu-item-has-children')) {
                        menu.addClass('is-level3');
                    // si élément du 2ème niveau
                    } else if ($(this).parents('.menu-item').parents('.menu-item').hasClass('menu-item-has-children')) {
                        menu.addClass('is-level2');
                    }
                });

                menu.find('.parent').on('click', function(e) {
                    e.preventDefault();

                    // si élément du 3ème niveau
                    if ($(this).parents('.menu-item').parents('.menu-item').parents('.menu-item').parents('.menu-item').hasClass('menu-item-has-children')) {
                        menu.removeClass('is-level3');
                    // si élément du 2ème niveau
                    } else if ($(this).parents('.menu-item').parents('.menu-item').parents('.menu-item').hasClass('menu-item-has-children')) {
                        menu.removeClass('is-level2');
                    } else {                        
                        menu.removeClass('is-submenu');
                    }
                    $(this).closest('.sub-menu').removeClass('is-active');
                    var self = $(this);
                    setTimeout(function() {                               
                        self.closest('.sub-menu').removeClass('is-actived');
                    }, 250);

                    menu.find('.slide-content').removeAttr('style');
                    menu.animate({scrollTop: 0}, 500);

                });
            }
            navHandler();

            //Langues selector
            $('header .languages>.current').click(function(){
                $(this).closest('.languages').toggleClass('is-active');
                
                if ($(this).attr('aria-expanded') == 'false') {
                    $(this).attr('aria-expanded', 'true');
                } else {                    
                    $(this).attr('aria-expanded', 'false');
                }
            });
        }

        //Fix Mobile 100VH
        function viewportHeightFixer() {
            if($(window).width()<1200){
                if(($('.bloc-header').length>0 && !$('.bloc-header').hasClass('half')) || $('.search_slide').length>0){
                    //$('body').append('<div id="hackviewport_percent" class="d-block" style="height:100%;width:0px;position:fixed;opacity:0;"></div>');							
                    //var heightpercent = $('#hackviewport_percent').height();
                    //if(heightpercent != window.innerHeight){
                    $('.bloc-header,.search_slide').each(function(elem){
                        if (!$(this).hasClass('basic')) {                            
                            $(this).height(window.innerHeight - $('header').outerHeight());
                        }
                    });
                    //}
                }
                if($(window).width()<769 && $('.menu_slide').length>0){
                    $('.menu_slide').height(window.innerHeight - $('header').outerHeight());
                }
            } else {
                // pour reset en cas de passage tablette vertical/horizontal
                if(($('.bloc-header').length>0 && !$('.bloc-header').hasClass('half')) || $('.search_slide').length>0){
                    $('.bloc-header,.search_slide').each(function(elem){
                        if (!$(this).hasClass('basic')) {                            
                            $(this).css('height', '');
                        }
                    });
                }
                if($(window).width()<769 && $('.menu_slide').length>0){
                    $('.menu_slide').css('height', '');
                }
            }
        }

        //Initialisation MagnificPopup
        function initVideos() {
            var videos = $('.bloc-video .video');

            if ($(window).width() <= 768) {
                var video = videos.find('.play');
                $(video).each(function() {
                    $(this).magnificPopup({
                        type: 'iframe',
                        items: {
                            src: $(this).attr('data-url')
                        },
                        mainClass: 'mfp-fade',
                        removalDelay: 160, 
                        preloader: false,
                        fixedContentPos: true,
                        overflowY: 'hidden'
                    });
                });            
            } else {
                var youtubeVideosArray = [];
                var facebookVideosArray = [];
                var players = [];

                videos.find('.play').on('click', function(e) {
                    e.preventDefault();

                    if ($(this).closest('.video').hasClass('youtube')) {
                        $(this).siblings('.youtube_player').addClass('active');
                        var iframe = $(this).siblings('.youtube_player').find('iframe');
                        iframe.addClass('active');
                        var symbol = iframe[0].src.indexOf("?") > -1 ? "&" : "?";
                        iframe[0].src += symbol + "autoplay=1";
                        // évite le bug ou la vidéo ne se lance pas automatiquement
                        iframe[0].src = iframe[0].src;
                    } else if ($(this).closest('.video').hasClass('facebook')) {
                        var id = $(this).attr('data-id');
                        $(this).siblings('.fb-video').addClass('active');
                        $(this).siblings('.fb-video').find('iframe').addClass('active');
                    } else if ($(this).closest('.video').hasClass('vimeo')) {
                        $(this).siblings('.vimeo_player').addClass('active');
                        var iframe = $(this).siblings('.vimeo_player').find('iframe');
                        iframe.addClass('active');
                        var symbol = iframe[0].src.indexOf("?") > -1 ? "&" : "?";
                        iframe[0].src += symbol + "autoplay=1";
                        // évite le bug ou la vidéo ne se lance pas automatiquement
                        iframe[0].src = iframe[0].src;
                    }else {
                        var url = $(this).attr('href');

                        $('<iframe>', {
                            src: url + '',
                            frameborder: 0,
                            scrolling: 'no',
                            class: 'active',
                            allow: 'autoplay ; fullscreen',
                        }).appendTo($(this).closest('.video'));
                    }
                });
            }
        }
        function parseUrl(url){
            var vimeoRegex = /(?:vimeo)\.com.*(?:videos|video|channels|)\/([\d]+)/i;
            var parsed = url.match(vimeoRegex);

            return "//player.vimeo.com/video/" + parsed[1] + '?autoplay=1';
        }

        //Menu Cookie depuis le menu footer WP
        $("footer li.cookie-open a").on('click', function() {
            tarteaucitron.userInterface.openPanel();
        });


        //Accordeons
        function initAccordeons() {
            var accordeons = $('.accordeon');
            accordeons.addClass('is-closed');
            accordeons.find('.accordeon-content').hide();

            var body = $('body');
            if (body.hasClass('page-template-annuaire-directions') || body.hasClass('single-action')) {
                var offsets = [];
                var i = 0;

                accordeons.each(function() {
                    offsets[i] = $(this).offset().top;
                    ++i;
                });

                i = 0;
            }

            accordeons.each(function() {
                var accordeon = $(this);
                var title = $(this).find('.accordeon-title');
                var content = $(this).find('.accordeon-content').first();

                title.off('click');
                title.on('click', function() {
                    if (accordeon.hasClass('is-closed')) {                        
                        // pour corriger bug de zoom google maps
                        var iframes = accordeon.find('iframe');
                        iframes.each(function() {
                            if ($(this)[0].src.indexOf("maps") >= 0 && !$(this).hasClass('is-loaded')) {                                
                                $(this)[0].src = $(this)[0].src;
                                $(this).addClass('is-loaded');
                            }
                        });
                        
                        accordeon.removeClass('is-closed');
                        title.attr('aria-expanded', 'true');
                        content.slideDown(400, function() {
                            // permet au éléments sticky de ne pas disparaître trop tot quand un accordéon est ouvert
                            var sticky = $('.sticky');
                            if (sticky.length > 0) {                                
                                var top = sticky.position().top;
                                var height = sticky.innerHeight();
                                var postWrapper = $('.post-wrapper');
                                var stopOffset = postWrapper.offset().top + postWrapper.outerHeight();
                                stickyHide = stopOffset - top - height - 70;
                            }
                            window.dispatchEvent(new Event('resize'));
                        });

                        if (body.hasClass('page-template-annuaire-directions') || body.hasClass('single-action')) {
                            if ($(window).width() < 1200) {
                                var minus = 100;
                            } else {
                                var minus = 120
                                }
                            var position = accordeon.attr('data-position');
                            var topOffset = offsets[position] - minus;

                            $('html, body').animate({scrollTop: topOffset}, 300);
                        }
                    } else {
                        accordeon.addClass('is-closed');
                        title.attr('aria-expanded', 'false');
                        content.slideUp(400, function() {
                            // permet au éléments sticky de ne pas disparaître trop tot quand un accordéon est ouvert
                            var sticky = $('.sticky');
                            if (sticky.length > 0) {
                                var top = sticky.position().top;
                                var height = sticky.innerHeight();
                                var postWrapper = $('.post-wrapper');
                                var stopOffset = postWrapper.offset().top + postWrapper.outerHeight();
                                stickyHide = stopOffset - top - height - 70;
                            }
                        });
                    }
                });
            });
        }

        //Btn scroll
        function initBtnScroll() {            
            $('.btn-scroll').click(function(e){
                e.preventDefault();
                var parent = $(this).parent();
                if ($(window).width() < 1200) {                
                    $('html, body').animate({ scrollTop: parent.innerHeight() + parent.offset().top }, 1000 ); // Go
                } else {
                    $('html, body').animate({ scrollTop: parent.innerHeight()}, 1000 );
                }
            });
        }

        //Effet Carré
        function initSquares() {            
            function square(){
                $('.square').each(function(){
                    $(this).height($(this).width());
                });
                $('.maxsquare').each(function(){
                    $(this).css('max-height',$(this).width());
                });
            }
            $(window).resize(function(){
                square();
            });
            square();

            //Réseaux sociaux
            if($('.bloc-social-wall .inst').length>0 && $(window).width()<570){
                $('.bloc-social-wall .inst').appendTo($('.bloc-social-wall .insta.container .row').first());
                $('.bloc-social-wall .insta.container .row .inst').removeClass('element').removeClass('card');
                $('.bloc-social-wall .insta.container .inst,.bloc-social-wall .insta.container .cover').addClass('square');
                square();
            }
            $('.bloc-social-wall .element-inner a').click(function(e){
                e.preventDefault();
                window.open($(this).attr('href'));
                return false;
            });


        }

        //Carousel
        function initCarousels() {            
            $('.ressources-carousel').owlCarousel({
                loop:false,
                margin:20,
                nav:false,
                dots: false,
                navText: ["<span class='arrow' aria-hidden='true'></span><span class='sr-only'>Slide précédent</span>", "<span class='arrow' aria-hidden='true'></span><span class='sr-only'>Slide suivant</span>"],
                responsive:{
                    0:{
                        items:1,
                        stagePadding: 15
                    },
                    700:{
                        items:2
                    },
                    992:{
                        items:3
                    },
                    1200: {
                        nav: true,
                        stagePadding: 30
                    }
                }
            });
        }

        // Carousel des catégories sur la page actu
        function initCategoriesCarousel() {
            $('.carousel').owlCarousel({
                loop:false,
                nav:false,
                dots: false,
                margin: 20,
                autoWidth: true,
                navText: ["<span class='arrow' aria-hidden='true'></span><span class='sr-only'>Slide précédent</span>", "<span class='arrow' aria-hidden='true'></span><span class='sr-only'>Slide suivant</span>"],
                stageElement: 'ul',
                itemElement: 'li',
                responsive:{
                    0:{
                        items:2,
                    },
                    700:{
                        items:4
                    },
                    992:{
                        items:5,
                        nav: true
                    },
                    1200: {
                        items:6,
                        nav: true
                    }
                },
                onInitialized: fixOwlCarousel,
                onRefreshed: fixOwlCarousel,
                onChange: hideLastItem
            });

            function fixOwlCarousel() {
                var stage = $('.owl-stage');
                stage.width(stage.width() * 2);
            }
            function hideLastItem(e) {
                if ($(window).width() >= 992) {                    
                    setTimeout(function(){
                        var activeItems = $('.carousel .owl-item.active');
                        var next = $('.carousel .owl-next')

                        if (!next.hasClass('disabled')) {
                            activeItems.last().addClass('is-hidden');
                            activeItems.last().prev().removeClass('is-hidden');
                            activeItems.last().prev().prev().removeClass('is-hidden');
                        } else {
                            activeItems.last().removeClass('is-hidden');
                        }
                    },1);
                }
            }
        }

        // Galerie
        function initGallery() {
            $('.galerie-carousel, .decors-carousel, .ports-carousel').each(function() {
                $(this).magnificPopup({
                    type: 'inline',
                    delegate: '.gallery-item',
                    mainClass: 'mfp-fade mfp-black',
                    fixedContentPos: true,
                    overflowY: 'hidden',
                    removalDelay: 300,
                    closeMarkup: '<div class="mfp-close"></div>',
                    gallery:{
                        arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><span class="arrow mfp-prevent-close"></span></button>',
                        enabled:true
                    },
                    callbacks: {
                        beforeOpen: function() {
                            var images = $(this)[0].ev.closest('.bloc-galerie').find('.images-container .item-image img');
                            images.each(function() {
                                var src = $(this).attr('data-src');
                                if (src.length) {
                                    $(this).attr('src', src);
                                    $(this).attr('data-src', '');
                                }
                            });
                        },
                        open: function() {
                            initGalleryInnerCarousels($(this)[0].currItem.index);
                            if (galerieCarousel != null) {
                                galerieCarousel.trigger("to.owl.carousel", [$(this)[0].currItem.index, 1]);
                            }
                        },
                        change: function() {
                            if (this.isOpen) {
                                this.wrap.addClass('mfp-open');
                                if (galerieCarousel != null) {
                                    galerieCarousel.trigger("to.owl.carousel", [$(this)[0].currItem.index, 1]);
                                }
                            }
                        }
                    }
                });
            });

            (function() {
                var magnificPopup = $.magnificPopup.instance;

                $('.galerie-modal .item-dots a').click(function(e) {
                    var image = $(this)[0].href.substring($(this)[0].baseURI.lastIndexOf('/') + 1);
                    var image = parseInt(image.replace('#image-', ''));
                    magnificPopup.goTo(image);
                });

                $(".gallery-item").click(function(e) {
                    setTimeout(function() {
                        $(".mfp-container").swipe( {
                            swipeLeft:function(event, direction, distance, duration, fingerCount) {
                                magnificPopup.next();
                            },
                            swipeRight:function(event, direction, distance, duration, fingerCount) {
                                magnificPopup.prev();
                            },
                        });
                    }, 500);
                });
            }).call(this);
        }
        
        // Communes
        function initCommunes() {
            var organismes = $('.organisme-popup');
            organismes.magnificPopup({
                type: 'inline',
                mainClass: 'mfp-fade popup-organisme',
                removalDelay: 160, 
                preloader: false,
                fixedContentPos: true,
                overflowY: 'hidden'
            });
        }

        //Carousels des galeries
        var galerieCarousel = null;
        function initGalleryInnerCarousels(start) {
            if ($(window).width() >= 1200) {
                galerieCarousel = $('.galerie-inner-carousel');
                console.log(galerieCarousel);
                galerieCarousel.owlCarousel({
                    loop:false,
                    margin:0,
                    nav:true,
                    stagePadding:20,
                    dots: false,
                    startPosition: start,
                    navText: ["<span class='arrow mfp-prevent-close'></span>", "<span class='arrow mfp-prevent-close'></span>"],
                    items: 7,
                    onInitialized: function(e) {
                        galerieCarousel.find('.owl-nav').addClass('mfp-prevent-close').find('button').addClass('mfp-prevent-close');
                    }
                });
            }
        }

        //Aides
        function changeThematique(thematique){
                if(thematique == 'developpement-economique'){
                     form.find('.conditional_economique').removeClass('d-none');
                     form.find('.champ_objectif,.champ_thematique').addClass('col-sm-6');
                }else{
                    form.find('.conditional_economique').addClass('d-none');
                    form.find('.conditional_economique select').val('').trigger('change');
                    form.find('.champ_objectif,.champ_thematique').removeClass('col-sm-6');
                }
        }

        function changeProfil(profil){
            var profil_slug = profil;
            var profil = $(this).find('option[value="'+profil+'"]').text();

            var data = {
                'action': 'countThematiquesFromProfil',
                'profil': profil_slug
            };

        }
        
        function GestionChampsNb(select,data){
            $.ajax({
                url: ajaxurl,
                data: data,
                type: 'POST',
                beforeSend: function ( xhr ) {
                    select.parent().find('button').addClass('is-loading');
                },
                success: function( data ){
                    select.parent().find('button').removeClass('is-loading');
                    var nbParOption = JSON.parse(data);
                    $.each(nbParOption,function(key,val){
                        var option = select.find('option[value="'+key+'"]');
                        var text = option.text();
                        var newText = text;
                        if(text.indexOf('(')>0){
                         newText = text.substring(0,text.indexOf('('));
                        }
                        newText += ' ('+val+')';
                        option.text(newText);
                        if(val==0){
                            option.attr('disabled',true);
                        }else{
                            option.removeAttr('disabled');
                        }
                    });
                    
                    //Tous les champs qui ne sont pas retournés sont marqués à 0.
                    select.find('option').each(function(){
                    
                        var text = $(this).text();
                        
                        if(text.indexOf('(') === -1 && !$(this).attr('hidden')){
                            var newText = text;
                            newText += ' (0)';
                            $(this).text(newText);
                            $(this).attr('disabled',true);
                        }
                    });
                    
                    if(select.parent().hasClass('dropdown')){
                        select.selectpicker('refresh');
                    }
                }
            });
        }
        //Aides
        function changeThematique(thematique){
                if(thematique == 'developpement-economique'){
                     form.find('.conditional_economique').removeClass('d-none');
                     form.find('.champ_objectif,.champ_thematique').addClass('col-sm-6');
                }else{
                    form.find('.conditional_economique').addClass('d-none');
                    form.find('.conditional_economique select').val('').trigger('change');
                    form.find('.champ_objectif,.champ_thematique').removeClass('col-sm-6');
                }
        }

        function changeProfil(profil){
                   var profil_slug = profil;
                   var profil = $(this).find('option[value="'+profil+'"]').text();
                    
                    
                if(profil_slug == 'entreprises-et-professionnels'){
                    form.find('.suggestion').removeClass('d-none');
                }else{
                    form.find('.suggestion').addClass('d-none');
                }
        }
        function changeCompteurThematique(select,profil,objectif){
            var data = {
                         'action': 'countThematiquesFromAide',
                         'profil': profil,
                         'objectif' : objectif
                     };
            GestionChampsNb(select,data);
        }
        
        
        
        function changeCompteurObjectifs(select,profil,thematique){
            var data = {
                   'action': 'countObjectifsFromAide',
                   'profil': profil,
                   'thematique' : thematique
               };
               GestionChampsNb(select,data);
                    
        }
        
        //Formulaire de recherche - guide des aides
        if ($('body').hasClass('page-template-aides')){
            var form = $('.filters-aides'); 
             
            if ($('#toggle_champ').hasClass('thematique')) { 
                    $('.champ_objectif .dropdown-toggle').find('.filter-option-inner-inner').text().replace('- ', '');
            }
            

    
            form.find('select[name="profil"]').change(function(){
                changeProfil($(this).val());
            });
            form.find('select[name="profil"]').on('changed.bs.select',function(e, clickedIndex, isSelected, previousValue){         
                changeProfil($(this).val());

            });

            form.find('select[name="thematique"]').change(function(){
                changeThematique($(this).val());
            });
            form.find('select[name="thematique"]').on('changed.bs.select',function(e, clickedIndex, isSelected, previousValue){         

                changeThematique($(this).val());

            });
            

            /**
           form.find('select[name="thematique"],select[name="profil"]').change(function(){
                  changeCompteurObjectifs($('select[name="objectif"]'), $('select[name="profil"]').val(),$('select[name="thematique"]').val());
            });
            form.find('select[name="thematique"],select[name="profil"]').on('changed.bs.select',function(e, clickedIndex, isSelected, previousValue){         
                 changeCompteurObjectifs($('select[name="objectif"]'), $('select[name="profil"]').val(),$('select[name="thematique"]').val());
            });

            
            
             form.find('select[name="profil"],select[name="objectif"]').change(function(){         
                 changeCompteurThematique($('select[name="thematique"]'),  $('select[name="profil"]').val(),$('select[name="objectif"]').val());
            });
            
            form.find('select[name="profil"],select[name="objectif"]').on('changed.bs.select',function(e, clickedIndex, isSelected, previousValue){         
                 changeCompteurThematique($('select[name="thematique"]'),  $('select[name="profil"]').val(),$('select[name="objectif"]').val());
            });
               */
            
            //Suggestion 
            form.find('#suggestion_entreprise').click(function(){
                $(this).parent().addClass('d-none');
                form.find('select[name="thematique"]').val('developpement-economique');
                form.find('select[name="thematique"]').trigger('change');
            });

            form.find('select').on('show.bs.select',function(e){
                $(this).parents( ".col-12" ).addClass('active');
            });
            form.find('select').on('hidden.bs.select',function(e){
                $(this).parents(".col-12").removeClass('active');
            });
            form.find('select').on('changed.bs.select',function(e, clickedIndex, isSelected){
                if ($(e.target).hasClass('is-optgroup')) {
                    var text = $(e.target).siblings('.dropdown-toggle').find('.filter-option-inner-inner').text().replace('- ', '');
                    $(e.target).siblings('.dropdown-toggle').find('.filter-option-inner-inner').text(text);
                }
            });
            form.find('select[name="profil"]').trigger('change');
            form.find('select[name="thematique"]').trigger('change');
            form.find('select[name="objectif"]').trigger('change');


            form.find('#toggle_champ').click(function(e){
                e.preventDefault();
                var txt = $(this).text();
                var toggle = $(this).attr('attr-toggle');
                $(this).text(toggle);
                $(this).attr('attr-toggle',txt);
                $(this).toggleClass('thematique');

                if($(this).hasClass('thematique')){
                    form.find('.champ_objectif').addClass('active').siblings().removeClass('active');
                }else{
                    form.find('.champ_thematique').addClass('active').siblings().removeClass('active');
                }
                form.find('.champs_dynamique>div:not(.active) .selectpicker').selectpicker('val', '');
            });


            $('.aide_cloturee input').change(function(){
                var returnCloture = 0;
                if($(this).prop('checked')){
                    returnCloture = 1;
                }
                form.find('input[name="cloture"]').attr('value',returnCloture);
                form.trigger('submit');
            });

            $('.aide_showall input').change(function(){
                var returnCloture = 0;
                if($(this).prop('checked')){
                    returnCloture = 1;
                }
                form.find('input[name="showall"]').attr('value',returnCloture);
                form.trigger('submit');
                //form.submit();
            });

         }
         
         
         
         
          function changeCompteurDelibThematique(select,type,session){
            var data = {
                   'action': 'countThematiqueFromDelibs',
                   'type': type,
                   'session' : session
               };
               GestionChampsNb(select,data);
        }
         function changeCompteurDelibSession(select,type,thematique){
            var data = {
                   'action': 'countSessionFromDelibs',
                   'type': type,
                   'thematique' : thematique
               };
               GestionChampsNb(select,data);
        } 
         
          //Formulaire de recherche - délibération
         if ($('body').hasClass('page-template-documents')){
                var form = $('.filters'); 
            
            form.find('select[name="type-de-doc"],select[name="session"]').change(function(){
                  changeCompteurDelibThematique($('select[name="thematique"]'), $('select[name="type-de-doc"]').val(),$('select[name="session"]').val());
            });
            form.find('select[name="type-de-doc"],select[name="session"]').on('changed.bs.select',function(e, clickedIndex, isSelected, previousValue){         
                 changeCompteurDelibThematique($('select[name="thematique"]'), $('select[name="type-de-doc"]').val(),$('select[name="session"]').val());
            });

            form.find('select[name="type-de-doc"],select[name="thematique"]').change(function(){         
                 changeCompteurDelibSession($('select[name="session"]'),  $('select[name="type-de-doc"]').val(),$('select[name="thematique"]').val());
            });
            
            form.find('select[name="type-de-doc"],select[name="thematique"]').on('changed.bs.select',function(e, clickedIndex, isSelected, previousValue){         
                 changeCompteurDelibSession($('select[name="session"]'),  $('select[name="type-de-doc"]').val(),$('select[name="thematique"]').val());
            });
        
        }
         
         
         function changeCompteurJobCategories(select,type,localisation){
            var data = {
                   'action': 'countCategorieFromOffre',
                   'type': type,
                   'localisation' : localisation
               };
               GestionChampsNb(select,data);
        }
         function changeCompteurJobLocalisation(select,type,categorie){
            var data = {
                   'action': 'countLocalisationFromOffre',
                   'type': type,
                   'categorie' : categorie
               };
               GestionChampsNb(select,data);
        } 
         
        if ($('body').hasClass('page-template-offres-emplois')){
            
            var form = $('.filters-aides'); 
            
            form.find('select[name="type"],select[name="localisation"]').change(function(){
                  changeCompteurJobCategories($('select[name="categorie"]'), $('select[name="type"]').val(),$('select[name="localisation"]').val());
            });
            form.find('select[name="type"],select[name="localisation"]').on('changed.bs.select',function(e, clickedIndex, isSelected, previousValue){         
                 changeCompteurJobCategories($('select[name="categorie"]'), $('select[name="type"]').val(),$('select[name="localisation"]').val());
            });

            
            
             form.find('select[name="type"],select[name="categorie"]').change(function(){         
                 changeCompteurJobLocalisation($('select[name="thematique"]'),  $('select[name="type"]').val(),$('select[name="categorie"]').val());
            });
            
            form.find('select[name="type"],select[name="categorie"]').on('changed.bs.select',function(e, clickedIndex, isSelected, previousValue){         
                 changeCompteurJobLocalisation($('select[name="localisation"]'),  $('select[name="type"]').val(),$('select[name="categorie"]').val());
            });
            
            
        }
        
        function changeCompteurAnnuaireGroupe(select,commission,fonction){
            var data = {
                   'action': 'countGroupeFromAnnuaire',
                   'commission': commission,
                   'fonction' : fonction
               };
               GestionChampsNb(select,data);
        }
         function changeCompteurAnnuaireCommission(select,groupe,fonction){
            var data = {
                   'action': 'countCommissionFromAnnuaire',
                   'groupe': groupe,
                   'fonction' : fonction
               };
               GestionChampsNb(select,data);
        }
        
         function changeCompteurAnnuaireFonction(select,groupe,commission){
            var data = {
               'action': 'countFonctionFromAnnuaire',
               'groupe': groupe,
               'commission': commission
           };
           GestionChampsNb(select,data);
        }
        
        
        
        function changeCompteurAnnuaireCollegeCeser(select,commission,fonction){
            var data = {
               'action': 'countCollegeCeserFromAnnuaire',
               'commission': commission,
               'fonction' : fonction
           };
           GestionChampsNb(select,data);
        }
         function changeCompteurAnnuaireCommissionCeser(select,college,fonction){
            var data = {
               'action': 'countCommissionCeserFromAnnuaire',
               'college': college,
               'fonction' : fonction
           };
           GestionChampsNb(select,data);
        }
        
         function changeCompteurAnnuaireFonctionCeser(select,college,commission){
            var data = {
               'action': 'countFonctionCeserFromAnnuaire',
               'college': college,
               'commission': commission
           };
           GestionChampsNb(select,data);
        } 
         
        if ($('body').hasClass('page-template-annuaire-elus')){
            
            var form = $('.filters'); 
            
            if(form.attr('attr-cpt')=='elu'){
                form.find('select[name="commission"],select[name="fonction"]').change(function(){
                   changeCompteurAnnuaireGroupe($('select[name="groupe"]'), $('select[name="commission"]').val(),$('select[name="fonction"]').val());
                });
                form.find('select[name="commission"],select[name="fonction"]').on('changed.bs.select',function(e, clickedIndex, isSelected, previousValue){         
                    changeCompteurAnnuaireGroupe($('select[name="groupe"]'), $('select[name="commission"]').val(),$('select[name="fonction"]').val());
                });
    
               form.find('select[name="groupe"],select[name="fonction"]').change(function(){
                      changeCompteurAnnuaireCommission($('select[name="commission"]'), $('select[name="groupe"]').val(),$('select[name="fonction"]').val());
                });
                form.find('select[name="groupe"],select[name="fonction"]').on('changed.bs.select',function(e, clickedIndex, isSelected, previousValue){         
                     changeCompteurAnnuaireCommission($('select[name="commission"]'), $('select[name="groupe"]').val(),$('select[name="fonction"]').val());
                });
                
                 
                form.find('select[name="groupe"],select[name="commission"]').change(function(){         
                     changeCompteurAnnuaireFonction($('select[name="fonction"]'), $('select[name="groupe"]').val(),$('select[name="commission"]').val());
                });
                form.find('select[name="groupe"],select[name="commission"]').on('changed.bs.select',function(e, clickedIndex, isSelected, previousValue){         
                     changeCompteurAnnuaireFonction($('select[name="fonction"]'), $('select[name="groupe"]').val(),$('select[name="commission"]').val());
                });
            }else if(form.attr('attr-cpt')=='ceser'){
               form.find('select[name="college"],select[name="fonction"]').change(function(){
                      changeCompteurAnnuaireCommissionCeser($('select[name="commission"]'), $('select[name="college"]').val(),$('select[name="fonction"]').val());
                });
                form.find('select[name="college"],select[name="fonction"]').on('changed.bs.select',function(e, clickedIndex, isSelected, previousValue){         
                     changeCompteurAnnuaireCommissionCeser($('select[name="commission"]'), $('select[name="college"]').val(),$('select[name="fonction"]').val());
                });
                
                
                form.find('select[name="commission"],select[name="fonction"]').change(function(){
                   changeCompteurAnnuaireCollegeCeser($('select[name="college"]'), $('select[name="commission"]').val(),$('select[name="fonction"]').val());
                });
                form.find('select[name="commission"],select[name="fonction"]').on('changed.bs.select',function(e, clickedIndex, isSelected, previousValue){         
                    changeCompteurAnnuaireCollegeCeser($('select[name="college"]'), $('select[name="commission"]').val(),$('select[name="fonction"]').val());
                });
    
                form.find('select[name="college"],select[name="commission"]').change(function(){         
                     changeCompteurAnnuaireFonctionCeser($('select[name="fonction"]'), $('select[name="college"]').val(),$('select[name="commission"]').val());
                });
                form.find('select[name="groupe"],select[name="commission"]').on('changed.bs.select',function(e, clickedIndex, isSelected, previousValue){         
                     changeCompteurAnnuaireFonctionCeser($('select[name="fonction"]'), $('select[name="college"]').val(),$('select[name="commission"]').val());
                });
            }else if(form.attr('attr-cpt')=='ccb'){
               
            }
        }
        
          
         function changeCompteurPresseThematique(select,type){
            var data = {
                   'action': 'countThematiqueFromPresse',
                   'cpt': type
               };
               GestionChampsNb(select,data);
        }  
          
        if ($('body').hasClass('page-template-espace-presse')){
            
            var form = $('.filters'); 
               changeCompteurPresseThematique($('select[name="thematique"]'), 'communiques');
         }
        
        
        

        // Fomulaire de contact
        function initFormLabels() {
            var inputs = $('.bloc-contact').find('input, textarea, select');
            inputs.on('focus', function() {
                $(this).closest('.item-input').siblings('.item-label').addClass('is-focused');
            });
            inputs.on('focusout', function() {
                var val = $(this).val();
                if (!val || val.length == 0) {
                    $(this).closest('.item-input').siblings('.item-label').removeClass('is-focused');
                }
            });
        }
        
        function initListSignup() {
            var wpcf7Elm = document.querySelector( '.wpcf7' );
            
            wpcf7Elm.addEventListener( 'wpcf7mailsent', function( event ) {
                console.log(event);
                
                var email = '';
                $(event.detail.inputs).each(function() {
                    if ($(this)[0].name == 'your-email') {
                        email = $(this)[0].value;
                    }
                });
                $(event.detail.inputs).each(function() {
                    if ($(this)[0].name == 'opt-in') {
                        if ($(this)[0].value == 'J’accepte de recevoir les informations liées à la Région Bretagne') {
                            console.log('oui');
                            addContact(email);
                        }
                    }
                });
            }, false );
        }
        function addContact(email) {            
            var data = {
                'action': 'createContact',
                'email': email
            };

            $.ajax({
                url: ajaxurl,
                data: data,
                type: 'POST',
                beforeSend: function() {
                },
                success: function(data) {
                    console.log(data);
                },
                error: function(data) {
                    console.log(data);
                }
            });
        }


        function responsiveVoiceInit(){
            $('button.btn-audiodescription').click(function(){
                $(this).toggleClass('active');
                if(!($(this).hasClass('playing'))){
                    var container = $('main article .post-content');
                    if($('body').hasClass('page')){
                        container = $('main > div > div >*:not(style)');
                    } 
                    $(this).find('.sr-only').text('Stopper l\'écoute du contenu de la page');
                    responsiveVoice.speak(container.text(),'French Female', {onend : ReinitResponsiveVoice});
                }else{
                    if($(this).hasClass('active')){
                        responsiveVoice.resume();
                        $(this).find('.sr-only').text('Stopper l\'écoute du contenu de la page');
                    }else{
                        responsiveVoice.pause();
                        $(this).find('.sr-only').text('Écouter le contenu de la page');
                    }
                }
                $(this).addClass('playing');
            });
        }
        function ReinitResponsiveVoice(){
            responsiveVoice.cancel();
            $('button.btn-audiodescription').removeClass('playing').removeClass('active');
            $(this).find('.sr-only').text('Écouter le contenu de la page');
        }
        if($('body').hasClass('single-post') ||
           $('body').hasClass('single-aide') ||
           $('body').hasClass('page')){
            responsiveVoiceInit();
        }

        // Blocs fixed sur les actus
        function setStickyElements() {
            if (($('body').hasClass('single-post')
                 || $('body').hasClass('single-aide')
                 || $('body').hasClass('single-offre-d-emploi')
                 || $('body').hasClass('single-film')
                 || $('body').hasClass('single-communique')
                 || $('body').hasClass('single-projet'))
                && $(window).width() >= 1200) {
                var sticky = $('.sticky');
                sticky.each(function() {
                    $(this).removeAttr('style');

                    var offset = $(this).offset();
                    var top = offset.top + 5;
                    var left = offset.left;
                    var width = $(this).innerWidth();

                    $(this).css({
                        position: 'fixed',
                        top: top,
                        left: left,
                        right: 'auto',
                        margin: 0,
                        width: width
                    });
                });

                var top = sticky.position().top;
                var height = sticky.innerHeight();
                var postWrapper = $('.post-wrapper');
                var stopOffset = postWrapper.offset().top + postWrapper.outerHeight();

                var blocEnPratique = postWrapper.find('.bloc-ressources');
                var blocEnPratiqueHeight = 0;
                if (blocEnPratique.length) {
                    blocEnPratiqueHeight = blocEnPratique.first().innerHeight() + 150;
                }
                
                stickyHide = stopOffset - top - height - blocEnPratiqueHeight - 60;
                
                $(window).off('scroll', throttle(listenStickyScroll, 100, false, true));
                $(window).on('scroll', throttle(listenStickyScroll, 100, false, true));
            }

            function listenStickyScroll() {
                if ($(window).scrollTop() >= stickyHide) {
                    sticky.fadeOut(100);
                } else {
                    sticky.fadeIn(100);
                }
            }            
        }

        //Barre de scroll actus
        function initProgressBar() {
            if ($('body').hasClass('single-post')){
                var progressBar = $('#progress-bar');
                var postWrapper = $('.post-wrapper');
                var end = postWrapper.offset().top + postWrapper.outerHeight() - ($(window).height() /2);

                $(window).off('scroll', moveProgressBar);
                $(window).on('scroll', moveProgressBar);
            }

            function moveProgressBar() {
                var progress = $(window).scrollTop();
                var percent = progress/end*100;

                if (percent > 100) {
                    percent = 100;
                }
                progressBar.css('width', percent + '%');
            }
        }
        
        // Aides marketées
        function initAideMarketee() {
            if ($('body').hasClass('single-aide')) {
                $('#btn-marketee').on('click', function(e) {
                    e.preventDefault();
                    $('#btn-marketee').addClass('disabled');
                    $('#btn-marketee-back').removeClass('disabled');
                    $('html, body').animate({ scrollTop: 0 }, 200 );
                    $('#aide-marketee-content').slideDown('100', function() {                        
                        $('#aide-content').slideUp('100', function() {
                            setStickyElements();
                        });
                    });
                });
                
                $('#btn-marketee-back').on('click', function(e) {
                    e.preventDefault();
                    $('#btn-marketee').removeClass('disabled');
                    $('#btn-marketee-back').addClass('disabled');
                    $('html, body').animate({ scrollTop: 0 }, 200 );
                    $('#aide-content').slideDown('100', function() {                        
                        $('#aide-marketee-content').slideUp('100', function() {
                            setStickyElements();
                        });
                    });
                });
            }
        }

        // Barre de recherche home
        function showSearchOnScroll() {
            var html = $('html');

            if ($(window).width() < 992) {
                var target = $('#search-mobile');
            } else {
                var target = $('#search-desktop');
            }
            var blocHeaderHeight = $('.search_slide').innerHeight();

            $(window).off('scroll', throttle(showHideSearchBar, 100, false, true));
            $(window).on('scroll', throttle(showHideSearchBar, 100, false, true));

            function showHideSearchBar() {
                if (!html.hasClass('is-fixed')) {                    
                    if ($(window).scrollTop() > blocHeaderHeight) {
                        target.addClass('is-visible');
                    } else {
                        target.removeClass('is-visible');
                    }
                }
            }
        }

        // Breadcrumb clamp
        function initBreadCrumbClamp() {            
            if (!$('body').hasClass('home') && $(window).width() <= 768) {
                var target = $('#breadcrumbs')[0];
                if (target != null) {                    
                    $clamp(target, {clamp: 2});
                }
            }
        }

        // Animation recherche
        function initSearchAnimation() {
            var i = 0;
            var target = $('#search-input').find('.search-trigger');
            var placeholder = target.attr('placeholder');
            var text = target.attr('data-text');
            var speed = 100;

            target.attr('placeholder', '');
            
            if (text != null) {                
                typeWriter();
            }

            function typeWriter() {
                if (i < text.length) {
                    target.attr('placeholder', target.attr('placeholder') + text.charAt(i));
                    ++i;
                    setTimeout(typeWriter, speed);
                }
            }
        }
        
        // auto scroll menu DM
        function initClickMenuDM() {
            var menuDM = $('#menu-dm');            
            $(menuDM).on('click', function() {
                $("html, body").animate({ scrollTop: $(document).height()}, 1000);
            });
        }
        
        // pour les optis d'accessibilité qu'on ne peut pas fix autrement
        function initOptisAccessibilite() {
            var blocNewsletter = $('.bloc.newsletter');            
            if (blocNewsletter.length) {
                var loader = blocNewsletter.find('.sib_loader');
                loader.attr('role', 'status')
                loader.find('img').attr('alt', 'Chargement en cours');
            }
            
            var cf7 = $('.wpcf7');
            if (cf7.length) {
                document.addEventListener( 'wpcf7invalid', function( event ) {
                    var tips = $('.wpcf7-not-valid-tip');
                    tips.removeAttr('aria-hidden');
                    tips.removeAttr('role');
                }, false );
                
                document.addEventListener( 'wpcf7submit', function( event ) {
                    var response = $('.wpcf7-response-output');
                    response.removeAttr('aria-hidden');
                    response.attr('role', 'alert');
                }, false );
                
                var select = $('.wpcf7-select');
                select.each(function() {
                    var options = $(this).find('option');
                    
                    if ($(this).val().length) {
                        $(this).closest('.form-item').find('.item-label').addClass('is-focused');
                    }
                    
                    options.each(function() {
                        if ($(this).attr('value') == '') {
                            if (!$(this).val().length) {                                
                                $(this).attr('selected', 'selected');
                            }
                            $(this).attr('disabled', 'disabled');
                            $(this).attr('hidden', 'hidden');
                        } 
                    });
                });
            }
        }

        // Resize
        function resize() {            
            viewportHeightFixer();
            showSearchOnScroll();

            setStickyElements();
            initProgressBar();
        }
        $(window).on('resize', throttle(resize, 100, false, true));


        /********
          UTILS
        ********/
        //Selector Bootstrap
        function initCustomSelectors(){
            if( /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) || $(window).width()<800) {

            } else {
                var selectPickers = $('.selectpickeritem');
                if (selectPickers.length) {                    
                    selectPickers.selectpicker({                
                        dropupAuto: false
                    });
                }
            }
            $('.selectpickeritem').on('show.bs.select', function (e, clickedIndex, isSelected, previousValue)  {
                // $(this).selectpicker('deselectAll');
                //  $(this).selectpicker('val', null );
            });

            //Gestion de la croix.
            $('.dropdown-toggle').click(function(e){
                if(!$(this).hasClass('bs-placeholder')){
                    e.preventDefault();
                    e.stopPropagation();
                    var width = $(this).width();
                    var mouseX = e.offsetX;

                    if(mouseX>(width-50)){
                        //On est sur la croix.
                        $(this).parent().find('.selectpickeritem').selectpicker('val', null );
                        $(this).trigger('click');
                        if ($(this).closest('.col-12').hasClass('aide_programmation') || $(this).hasClass('aide_fonds')) {
                            $(this).siblings('select').trigger('change');
                        }
                    }
                }
            });

            //Pour les select qui conservent leurs placeholder
            $('.selectpickeritem.keepPlaceholder').on('changed.bs.select', function () {
                $(this).next().find('.placeholder').remove();
                if($(this).val()!=null){
                    var placeholder = $(this).attr('data-name');
                    if(placeholder==undefined){
                        placeholder = $(this).attr('title');
                    }
                    $('<div class="placeholder">'+placeholder+'</div>').insertBefore($(this).next().find('.filter-option-inner'));
                }
            });
            //Pour les select qui ont une navigation en carousel par optgroup
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {

            } else {
                var selectPickersGroupSLide = $('.selectpickeritem.groupSlide');
                if (selectPickersGroupSLide.length) {                    
                    selectPickersGroupSLide.selectpicker('refresh');
                }
                $('.bootstrap-select.groupSlide').each(function(){
                    var activeOptGroup = 1;
                    $(this).on('show.bs.select', function () {

                        var actives = $(this).find('li.optgroup-'+activeOptGroup+'.dropdown-header ,li.optgroup-'+activeOptGroup+' a');
                        $(this).find('li,li>a').removeClass('show');
                        actives.addClass('show');
                        var headers = $(this).find('li.dropdown-header');
                        headers.each(function(header){
                            if($(this).find('span.next, span.prev').length==0){
                                if($(this).find('~ .dropdown-header').length>0){
                                    $(this).prepend('<span class="prev">prev</span>');
                                    $(this).find('.prev').click(function(){
                                        ++activeOptGroup;
                                        actives = $(this).parent().parent().find('li.optgroup-'+activeOptGroup+'.dropdown-header ,li.optgroup-'+activeOptGroup+' a');
                                        $(this).parent().parent().find('li,li>a').removeClass('show');
                                        actives.addClass('show');
                                    });
                                }
                                if(!$(this).hasClass('optgroup-1')){
                                    $(this).append('<span class="next">next</span>');
                                    $(this).find('.next').click(function(){
                                        activeOptGroup--;
                                        actives = $(this).parent().parent().find('li.optgroup-'+activeOptGroup+'.dropdown-header ,li.optgroup-'+activeOptGroup+' a');
                                        $(this).parent().parent().find('li,li>a').removeClass('show');
                                        actives.addClass('show');
                                    });
                                }

                            }

                        });
                    });
                });
            }
        }
        //Checkbox Switchers
        function initCustomCheckbox(){
            $('.switchCheckbox').each(function(){
                $('<div class="state" aria-hidden="true"><label>Fill</label></div>').insertAfter($(this)); 
            });
        }


        // Throttle
        function throttle(func, wait, leading, trailing, context) {
            var ctx, args, result;
            var timeout = null;
            var previous = 0;
            var later = function() {
                previous = new Date;
                timeout = null;
                result = func.apply(ctx, args);
            };
            return function() {
                var now = new Date;
                if (!previous && !leading) previous = now;
                var remaining = wait - (now - previous);
                ctx = context || this;
                args = arguments;
                if (remaining <= 0) {
                    clearTimeout(timeout);
                    timeout = null;
                    previous = now;
                    result = func.apply(ctx, args);
                } else if (!timeout && trailing) {
                    timeout = setTimeout(later, remaining);
                }
                return result;
            };
        };
        
        // récupère les paramètres d'url d'une aide et les stocke dans le localStorage
        function setAidesParams() {
            if ($('body').hasClass('single-aide')) {
                var url = window.location.href;
                var params = url.split('?')[1];

                if (params != null) {            
                    sessionStorage.setItem('aidesParams', '?' + params);
                }
            }
        }
    });

})(jQuery, this);
(function($) {
    jQuery('#mdb-form').focus(function(){
        //open bootsrap modal
        jQuery('#mdb-formModal').modal({
           show: true
        });
    });
    // Bandeau
    var messageBandeau = $('#message-bandeau');
    if (messageBandeau.length) {                
        $(window).on('load', function(){
            messageBandeau.addClass('is-active');
        });
    }  
})(jQuery);